module.exports = __webpack_public_path__ + "img/0059d40.png";